
import { Options, Vue } from 'vue-class-component';
import TypewriterEffect from '@/components/TypewriterEffect.vue'; // @ is an alias to /src
import htmlVisibility from '@/components/HtmlVisibility.vue';
@Options({
	components: {
		TypewriterEffect,
		htmlVisibility
	},
	data() {
		return{
			customText: "because water should be free",
		}
	},
	methods: {
		redirectTo: function(path: String){
			this.$router.push(path);
		}
	}
})
export default class HomeView extends Vue {
}
